import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';
import VideoStreamTV from './VideoStreamTV';

import Geosuggest from 'react-geosuggest';

import './Videos.css';
import { EventViewSplitPane } from './Event'
import { Modal, ComboBox, PublicityPicker, PhonePicker, ConfirmModal, EmptyState, LoadingState, FeedBackPopUp } from './Common';

export default class Videos extends Component {
    constructor(p) {
        super(p)
        this.state = {
            activeTab: "Uploads",//(!this.props.isAdmin)?this.props.author.split(" ")[0]+"'s Videos":"Your Videos",
            userTabs: ["Uploads","Featured"],//(!this.props.isAdmin)?["Videos of "+this.props.author.split(" ")[0], this.props.author.split(" ")[0]+"'s Videos"]:["Videos of You", "Your Videos"],
            videos: [],
            featured: [],
            isLoadingVids: true,
            isLoadingFeats: true
        }
    }

    componentDidMount(){
        this._isMounted = true;
        this.getVideos()
        this.getFTVideos();
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    canSee = () => {
        const _ = FakeData.___(this.props.userType, {
          "can_see_posts":"Friends",
          "can_see_tagged_posts":true,
          "who_to_see_posts":"Friends"
        }, this.props.user, []);
    
        return _;
    }

    getVideos = () => {
        const _that = this;
        const _ = this.canSee();
        if(!_.can_see_posts || !_.can_see_tagged_posts || !_.who_to_see_posts){
            return;
        }
        const dataTo = {
            userId: this.props.user.id,
            userType: this.props.userType,
            yourId: FakeData.getData("yoo").id
        }

        FakeData.post(FakeData.apiURL+"/get-user-videos", dataTo, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: "POST",
            success(res) {
                if(!_that._isMounted){
                    return;
                }
                _that.setState({
                    videos: res,
                    isLoadingVids: false
                })
            },
            error(error) {
                if(!_that._isMounted){
                    return;
                }
                _that.setState({
                    videos: [],
                    isLoadingVids: false
                })
            }
        });
    }

    getFTVideos = () => {
        const _that = this;
        const _ = this.canSee();
        if(!_.can_see_posts || !_.can_see_tagged_posts || !_.who_to_see_posts){
            return;
        }
        const dataTo = {
            userId: this.props.user.id,
            userType: this.props.userType,
            yourId: FakeData.getData("yoo").id
        }

        FakeData.post(FakeData.apiURL+"/get-user-feature-videos", dataTo, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: "POST",
            success(res) {
                if(!_that._isMounted){
                    return;
                }
                _that.setState({
                    featured: res,
                    isLoadingFeats: false
                })
            },
            error(error) {
                if(!_that._isMounted){
                    return;
                }
                _that.setState({
                    featured: [],
                    isLoadingFeats: false
                })
            }
        });
    }

    render() {
        const _ = this.canSee();
        if(!_.can_see_posts || !_.can_see_tagged_posts || !_.who_to_see_posts){
            return(
                <div className="default-view" style={{ backgroundColor: "#fff",  paddingBottom: "20px" }}>
                    <EmptyState icon="block" isShown={true} text={"Content viewing was disabled by admin"}/>
                </div>
            )
        }

        return (
            <div className="default-view" style={{ backgroundColor: "#fff",  paddingBottom: "20px" }}>
                <div className="view-with-tabs">
                    <div className="view-with-tabs-head">
                        {
                            this.state.userTabs.map((item, i) => {
                                
                                return (
                                    <div key={i} className={(item === this.state.activeTab) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ activeTab: item })}>{item}</div>
                                )
                            })
                        }
                    </div>
                    <div className="view-with-tabs-body">
                        {this.state.activeTab==="Uploads" && <VideoList videos={this.state.videos} isLoading={this.state.isLoadingVids} profile={this.props.user} isAdmin={this.props.user.isAdmin} />}
                        {this.state.activeTab==="Featured" && <VideoList videos={this.state.featured} isLoading={this.state.isLoadingFeats} profile={this.props.user} isAdmin={this.props.user.isAdmin} />}
                    </div>
                </div>
            </div>
        );
    }
}

class VideoList extends Component{
    constructor(props){
        super(props)
        this.state = {

        }
    }

    render(){
        const {videos, profile, isAdmin, isLoading} = this.props;
        if(isLoading){
            return(
                <LoadingState text={"Loading Videos"}/>
            )
        }

        if(videos.length===0){
            return(
                <EmptyState isShown={true} text="No videos were found!" icon="theaters" />
            )
        }
        
        return(
            <div className={"video-profile-list"}>
                {
                    videos.map((video, i)=>{
                        return(
                            <VideoItem key={video._id} video={video} videos={videos} />
                        );
                    })
                }
            </div>
        )
    }
}

class VideoItem extends Component{
    constructor(props){
        super(props)
        this.state = {
            isWatching: false,
            hasImage: true
        }
    }

    render(){
        const {video, videos} = this.props
        const {isWatching, hasImage} = this.state

        return(
            <div className={"video-profile-list-item"}>
                <a className="icon-play" onClick={()=>{
                    this.setState({ isWatching: true });
                }}></a>
                {hasImage && <img src={video.poster} onError={()=>this.setState({ hasImage: false })}/>}
                {!hasImage && video.user && <img src={video.user.image} onError={()=>this.setState({ hasImage: false })}/>}
                {isWatching && (
                    <VideoStreamTV
                        onClose={() => {
                            this.setState({ isWatching: false });
                        }}
                        videos={videos}
                        user={{
                            name: FakeData.getData("yoo").id,
                            image: FakeData.getData("yoo").image,
                            id: FakeData.getData("yoo").id,
                            type: "F"
                        }}
                        vid_id={video._id}
                        video={video}
                        isLive={false}
                        style={{
                            zIndex: 9999,
                            background: 'url(".././images/stadium_background.jpg")'
                        }}
                    />
                    )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Videos.js